var classof = require('../internals/classof-raw');

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es-x/no-array-isarray -- safe
module.exports = Array.isArray || function isArray(argument) {
  return classof(argument) == 'Array';
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/is-array.js
// module id = 49
// module chunks = 0